export const PlatinumIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
  >
    <g clip-path="url(#clip0_1595_7553)">
      <mask
        id="mask0_1595_7553"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="72"
        height="72"
      >
        <path d="M72 0H0V72H72V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1595_7553)">
        <path
          d="M26.0999 49.7995L35.6998 71.6003C35.6998 71.701 35.599 71.701 35.599 71.701L16.8989 49.8017H26.0999V49.7995ZM17.2999 29.6992H0.100769C0.100769 30.3982 1.20078 31.2988 1.20078 31.2988L16.9011 49.7995L23.2009 43.0987L17.2999 29.6992Z"
          fill="#4C00D1"
        />
        <path
          d="M71.5004 30.5009C71.0008 31.0005 70.201 31.0005 69.7014 30.5009C69.5019 30.3015 69.3004 29.9005 69.3004 29.6003H54.5993L45.3982 19.5995L54.9981 9.5L71.2988 28.6011C71.2988 28.6011 71.2988 28.7019 71.3996 28.7019H71.5004C72 29.3023 72 30.1021 71.5004 30.5009ZM35.8992 29.7011L45.2996 19.7003L35.8992 9.5L26.4987 19.7003L35.8992 29.7011Z"
          fill="#A476FF"
        />
        <path
          d="M36.3 71.6989C36.1992 71.7997 36.1006 71.6989 36.1992 71.5981L45.799 49.7973H55.0001L36.3 71.6967V71.6989ZM48.7002 43.0987L55.0001 49.7995L71.3994 30.5998C71.3994 30.5998 71.8004 29.9994 71.8004 29.6992H54.6013L48.7002 43.0987Z"
          fill="#9659FC"
        />
        <path
          d="M26.5009 19.6992L17.2999 29.7001H35.8992L26.4987 19.6992H26.5009Z"
          fill="#7327FF"
        />
        <path
          d="M45.4004 19.6992L35.9014 29.7001H54.6015L45.4004 19.6992Z"
          fill="#CDB0FF"
        />
        <path
          d="M26.5009 19.6989L17.2999 29.6998H0.100769C0.100769 29.6998 0.201566 29.0994 0.600373 28.7006L16.3993 10.1999C16.5001 10.0991 16.5987 10.0005 16.6995 10.0005C16.8989 9.70028 17.1991 9.59949 17.6001 9.59949C18.2991 9.59949 18.8009 10.1999 18.8009 10.8003C18.8009 10.9997 18.7001 11.2013 18.6015 11.4007L26.5009 19.7011V19.6989ZM35.9014 29.6998L48.7004 43.2001L54.6015 29.6998H35.9014ZM17.3021 29.6998L23.2031 43.2001L36.0022 29.6998H17.3021ZM26.1021 49.8001L35.8028 71.8002C35.9036 71.901 36.0022 71.901 36.103 71.8002L45.8036 49.8001H26.1043H26.1021ZM48.7026 43.0993L45.8036 49.8001H55.0047L48.7048 43.0993H48.7026Z"
          fill="#6000FF"
        />
        <path
          d="M45.4002 19.7003L35.9012 9.5H55.0023L45.4024 19.7003H45.4002ZM35.9012 9.5H18.0009C17.5999 9.5 16.8001 9.5 17.1003 9.8002L26.5007 19.7003L35.9012 9.5Z"
          fill="#9659FC"
        />
        <path
          d="M23.2009 43.0996L16.9011 49.8004H26.1021L23.2031 43.0996H23.2009Z"
          fill="#5725A8"
        />
        <path
          d="M23.2009 43.0987L26.0999 49.7995H45.7992L48.7004 43.0987L35.9013 29.6992L23.2009 43.0987Z"
          fill="#4C00D1"
        />
        <path
          d="M52.6995 29.9006C55.3991 30.5996 57.5005 32.701 58.1995 35.4006C58.3003 35.7008 58.6005 35.7008 58.6991 35.4006C59.3981 32.701 61.4995 30.5996 64.1991 29.9006C64.4993 29.7998 64.4993 29.4996 64.1991 29.401C61.4995 28.702 59.3981 26.6005 58.6991 23.9009C58.5983 23.6007 58.2981 23.6007 58.1995 23.9009C57.5005 26.6005 55.3991 28.702 52.6995 29.401C52.3993 29.5018 52.3993 29.802 52.6995 29.9006Z"
          fill="white"
        />
        <path
          d="M42.6 3.5998C44.0002 4.0008 45.1002 5.10081 45.499 6.49882C45.499 6.59962 45.6984 6.59962 45.6984 6.49882C46.0994 5.09862 47.1994 3.99861 48.5975 3.5998C48.6983 3.5998 48.6983 3.4004 48.5975 3.4004C47.1972 2.9994 46.0972 1.89939 45.6984 0.501379C45.6984 0.400582 45.499 0.400582 45.499 0.501379C45.098 1.90159 43.998 3.00159 42.6 3.4004C42.4992 3.4004 42.4992 3.5998 42.6 3.5998Z"
          fill="#CDB0FF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1595_7553">
        <rect width="72" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
